import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBlueSquare = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21 3.5C21.5523 3.5 22 3.94772 22 4.5V20.5C22 21.0523 21.5523 21.5 21 21.5H3C2.44772 21.5 2 21.0523 2 20.5V4.5C2 3.94772 2.44772 3.5 3 3.5H21ZM15 5.5H4V19.5H15V5.5ZM20 5.5H17V19.5H20V5.5Z",
		fill: "#0587FB"
	})
});
export default SvgIconBlueSquare;
